import React, { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { Alert } from 'antd';

//compnents
import BWAccordion from 'components/shared/BWAccordion/index';
import { showConfirmModal } from 'actions/global';

import { msgError } from 'pages/Prices/helpers/msgError';
import CheckAccess from 'navigation/CheckAccess';
import { useDispatch } from 'react-redux';
import { checkProductType } from '../contain/contain';
import { formatPrice } from 'utils/index';
import { formatWarrantyNumber } from 'pages/WarrantyManagement/warrantyNumber';

const getReferenceCostPrice = (item = {}) =>
  Number(item?.reference_cost_price || item?.cost_basic_imei_code || item?.price_cost_avg || item?.total_price_cost || item?.cost_price || 0);

const ProductList = ({ id, title, disabled, paramHidden, vietnameseNumbers = false, compact = false }) => {
  const methods = useFormContext();

  const {
    formState: { errors },
  } = methods;

  const dispatch = useDispatch();

  const handleDelete = (key = '', keyValue = '') => {
    let _ojectValue = methods.watch(`${key}`);

    if (_ojectValue[`key${keyValue}`]) {
      delete _ojectValue[`key${keyValue}`];
    }
    // lưu giá trị thay đổi
    methods.setValue(`${key}`, _ojectValue);
  };

  const columns = useMemo(
    () => [
      {
        header: 'STT',
        styleHeader: { width: 100 },
        classNameHeader: ' bw_text_center',
        classNameBody: 'bw_text_center',
        formatter: (p, idx) => <b className='bw_sticky bw_name_sticky'>{idx + 1}</b>,
      },
      {
        header: 'Mã Imei',
        accessor: 'product_imei',
        disabled: true,
        hidden: paramHidden !== checkProductType['1'],
      },
      {
        header: 'Kho',
        accessor: 'stocks_name',
        disabled: true,
        hidden: paramHidden !== checkProductType['1'],
      },
      {
        header: 'Thời gian kích hoạt',
        accessor: 'activation_date',
        disabled: true,
        hidden: paramHidden !== checkProductType['1'],
      },
      {
        header: 'Mã sản phẩm / Model',
        classNameHeader: 'bw_w2',
        formatter: (p) => <b>{p?.product_code}</b>,
      },
      {
        header: 'Tên sản phẩm / Model',
        formatter: (p) => <span>{p?.product_name}</span>,
      },
      {
        header: 'ĐVT',
        classNameHeader: 'bw_text_center',
        classNameBody: 'bw_text_center',
        formatter: (p) => <span>{p?.unit_name}</span>,
        hidden: paramHidden === checkProductType['3'],
      },
      {
        header: 'Giá vốn',
        classNameHeader: 'bw_text_center',
        classNameBody: 'bw_text_center',
        formatter: (p) => {
          const referenceCostPrice = getReferenceCostPrice(p);
          return referenceCostPrice || (compact && p.reference_cost_price !== null && p.reference_cost_price !== undefined) ? (
            <span className='bw_label bw_label_warning'>{vietnameseNumbers ? formatWarrantyNumber(referenceCostPrice, 4) : formatPrice(referenceCostPrice, false, ',')} VNĐ</span>
          ) : (
            <span>Chưa có</span>
          );
        },
        hidden: paramHidden === checkProductType['3'],
      },
      {
        header: 'Ngành hàng',
        accessor: 'category_name',
        hidden: paramHidden === checkProductType['3'],
      },
      {
        header: 'Model sản phẩm',
        accessor: 'model_name',
        hidden: paramHidden === checkProductType['3'],
      },
      {
        header: 'Nhà sản xuất',
        accessor: 'manufacture_name',
        hidden: paramHidden === checkProductType['3'],
      },
    ].filter(column => !compact || ['STT', 'Mã Imei', 'Mã sản phẩm / Model', 'Tên sản phẩm / Model', 'Giá vốn'].includes(column.header)),
    [paramHidden, vietnameseNumbers, compact],
  );

  const renderData = useCallback(
    (valueRender, keyRender) => (
      <tr>
        {columns?.map((column, key) => {
          if (!column.hidden) {
            if (column.formatter) {
              return (
                <td className={column?.classNameBody} style={column?.styleBody} key={`${keyRender}${key}`}>
                  {column?.formatter(valueRender, keyRender)}
                </td>
              );
            } else if (column.accessor) {
              return (
                <td className={column?.classNameBody} style={column?.styleBody} key={`${keyRender}${key}`}>
                  {valueRender[column.accessor]}
                </td>
              );
            } else {
              return <td className={column?.classNameBody} style={column?.styleBody} key={`${keyRender}${key}`}></td>;
            }
          }
        })}
        {methods.watch('product_list') && Object.values(methods.watch('product_list')).length > 1 ? (
          <td className='bw_sticky bw_action_table bw_text_center'>
            <CheckAccess permission={['SL_PRICES_ADD', 'SL_PRICES_EDIT']}>
              <a
                disabled={disabled}
                onClick={() => {
                  if (!disabled) {
                    dispatch(
                      showConfirmModal(msgError['model_error'], async () => {
                        handleDelete('product_list', valueRender?.product_id);
                      }),
                    );
                  }
                }}
                style={{
                  marginRight: '2px',
                }}
                className={`bw_btn_table bw_red`}>
                <i className={`fi fi-rr-trash`}></i>
              </a>
            </CheckAccess>
          </td>
        ) : null}
      </tr>
    ),
    [columns],
  );
  const showActionColumn = methods.watch('product_list') && Object.values(methods.watch('product_list')).length > 1;
  const visibleColumnCount = columns.filter((p) => !p?.hidden).length + (showActionColumn ? 1 : 0);

  return (
    <React.Fragment>
      <BWAccordion title={title} id={id}>
        {errors['product_list'] && <Alert type={'error'} message={errors['product_list']?.message} showIcon />}

        <div className='bw_table_responsive bw_mt_1'>
          <table className='bw_table'>
            <thead>
              <tr>
                {columns?.map((p, idx) =>
                  !p?.hidden ? (
                    <th key={idx} className={p?.classNameHeader} style={p?.styleHeader}>
                      {p?.header}
                    </th>
                  ) : null,
                )}
                {showActionColumn ? (
                  <th className='bw_sticky bw_action_table bw_text_center' style={{ width: '7%' }}>
                    Thao tác
                  </th>
                ) : null}
              </tr>
            </thead>
            <tbody>
              {methods.watch('product_list') && Object.values(methods.watch('product_list')).length ? (
                Object.values(methods.watch('product_list'))?.map((value, key) => {
                  return renderData(value, key);
                })
              ) : (
                <tr>
                  <td colSpan={visibleColumnCount || 1} className='bw_text_center'>
                    Không có dữ liệu
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </BWAccordion>
    </React.Fragment>
  );
};

export default ProductList;
